module.exports = __webpack_public_path__ + "static/img/gpt24.e234961d.png";